/**
 * Catalog Tab Component
 *
 * Displays entity data using MetadataTable, dynamically switching based on selected entity.
 *
 * Features (all metadata-driven):
 * - Data fetching from /{entity}/search
 * - Pagination, sorting, filtering
 * - Presets, search, advanced filters
 * - Column customization
 * - Detail drawer (create/edit/view)
 * - Lifecycle actions
 * - Bulk operations
 * - Record comparison
 *
 * Uses view metadata (useViewMetadata=true) to display enriched audit fields:
 * - createdByName, modifiedByName (human-readable instead of UUIDs)
 * - connectionName (source connection for imported records)
 */

import { MetadataTable } from '@/components/MetadataTable'
import type { EntityType } from '../types'

interface CatalogTabProps {
  /** The selected entity type to display (e.g., 'offerings', 'uoms', 'currencies') */
  selectedEntity: EntityType
}

export function CatalogTab({ selectedEntity }: CatalogTabProps) {
  // Build endpoint from entity key (e.g., 'offerings' -> '/offerings')
  const endpoint = `/${selectedEntity}`

  return (
    <MetadataTable
      key={selectedEntity} // Force remount when entity changes to reset table state
      endpoint={endpoint}
      useViewMetadata={true}
    />
  )
}
